import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function SocialProofSection() {
  const testimonials = [{
    company: 'SecureTech Solutions',
    location: 'Dubai, UAE',
    contact: 'Ahmed K.',
    role: 'Procurement Manager',
    text: 'GS HRC has been our go-to supplier for hardware wallets across the Middle East. Their response time and product availability are excellent.',
    rating: 5
  }, {
    company: 'CryptoVault Distribution',
    location: 'Singapore',
    contact: 'Lisa Chen',
    role: 'Operations Director',
    text: 'Reliable partner for bulk orders. They understand the security hardware market and always deliver authentic products with proper documentation.',
    rating: 5
  }, {
    company: 'Digital Shield Europe',
    location: 'Amsterdam, Netherlands',
    contact: 'Marcus V.',
    role: 'Supply Chain Lead',
    text: 'We have worked with GS HRC for over two years. Their product range and competitive MOQs make them ideal for our regional distribution needs.',
    rating: 5
  }];
  const stats = [{
    value: '2017',
    label: 'Established'
  }, {
    value: '30+',
    label: 'Countries Served'
  }, {
    value: '500K+',
    label: 'Units Distributed'
  }, {
    value: '98%',
    label: 'Customer Satisfaction'
  }];
  return <section id="social-proof" className="py-20 px-6 relative overflow-hidden bg-gradient-to-br from-[#F6F8FB] to-white" data-id="element-237">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-238" />
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-239">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-240">
          <h2 className="text-4xl font-bold text-[#0B1220] mb-4" data-id="element-241">
            Trusted by Businesses Worldwide
          </h2>
          <p className="text-lg text-gray-600" data-id="element-242">
            Authorized partnerships since 2017
          </p>
        </motion.div>
        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16" data-id="element-243">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 text-center shadow-sm border border-gray-100" data-id="element-244">
              <div className="text-3xl font-bold text-[#3B82F6] mb-2" data-id="element-245">
                {stat.value}
              </div>
              <div className="text-sm text-gray-600" data-id="element-246">{stat.label}</div>
            </motion.div>)}
        </div>
        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-247">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-248">
              <QuoteIcon className="w-8 h-8 text-[#3B82F6] mb-4 opacity-50" data-id="element-249" />
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-250">
                {testimonial.text}
              </p>
              <div className="flex items-center gap-1 mb-4" data-id="element-251">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-[#10B981] text-[#10B981]" data-id="element-252" />)}
              </div>
              <div className="border-t border-gray-100 pt-4" data-id="element-253">
                <p className="font-semibold text-[#0B1220]" data-id="element-254">
                  {testimonial.contact}
                </p>
                <p className="text-sm text-gray-600" data-id="element-255">{testimonial.role}</p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-256">
                  {testimonial.company} • {testimonial.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}